<script setup lang="ts">
const props = defineProps<{
    text?: string
    variant: 'warning'
}>()
</script>

<template>
    <div :class="['label', `_${props.variant}`]">
        <div :class="['label__icon', `_${props.variant}`]">
            <slot name="icon" />
        </div>

        <div class="label__text">
            <slot name="text">{{ props.text }}</slot>
        </div>
    </div>
</template>

<style lang="scss" src="./VLabel.scss"></style>
